import { useInstanceSelectionsByValueKey, useSelections } from '@k3/core'
import {
  SidewallContextType,
  SidewallResultContext,
  useSidewallResultContext,
} from '../../../../hooks/state/useSidewall'
import { Keys } from '../../../../hooks/state/utlility/utils'
import { SideWall } from './SideWall'
import { isForbiddenValues } from '../../../../hooks/state/isForbiddenValues'

function getContexts(
  type: (typeof Keys.Seitenwände.Values)[keyof typeof Keys.Seitenwände.Values]['key']
) {
  const selectionStuff = useInstanceSelectionsByValueKey(type)
  const keys = Object.keys(selectionStuff)
  const selections = useSelections()

  // TODO: this should be sorted in the useInstanceSelectionsByValueKey hook
  const selectionsById = keys.reduce((acc, key) => {
    const selection = selections.find((s) => s.id === key)
    return selection ? { ...acc, [key]: selection.sort ?? 0 } : acc
  }, {} as Record<string, number>)

  const contexts = Object.values(selectionStuff)
    .map((m, index) => ({
      id: keys[index],
      sort: selectionsById[keys[index]],
      type,
      index,
      ...m,
    }))
    .sort((a, b) => a.sort - b.sort)
    .map((m, index) => {
      return {
        ...m,
        index,
      }
    })

  return contexts
}

const SidewallContextProvider = ({
  sidewallContext,
}: {
  sidewallContext: SidewallContextType
}) => {
  const sideWallResultContext = useSidewallResultContext(sidewallContext)

  return (
    <SidewallResultContext.Provider
      key={sidewallContext.id}
      value={sideWallResultContext}
    >
      <SideWall key={sidewallContext.id} />
    </SidewallResultContext.Provider>
  )
}

function renderSideWalls(contexts: SidewallContextType[]) {
  return contexts.map((sidewallContext) => (
    <SidewallContextProvider
      key={sidewallContext.id}
      sidewallContext={sidewallContext}
    />
  ))
}

export const SidewallSpawner = () => {
  const sidewalls = Object.values(Keys.Seitenwände.Values).map((value) => {
    // @ts-ignore
    const contexts = getContexts(isForbiddenValues(value))
    // @ts-ignore
    return renderSideWalls(contexts)
  })

  return <group>{sidewalls}</group>
}
